import { useSelector } from 'react-redux';
import { selectModulesLookup } from '@pages/modules/store/selectors';

const useModuleObject = (moduleId) => {
    const modulesLookup = useSelector(selectModulesLookup);
    const moduleObject = modulesLookup[moduleId];

    if (!Object.keys(modulesLookup) || !moduleId) {
        return null;
    }

    return moduleObject;
};

export default useModuleObject;
